<template>
  <div id="app">
    <leftNav class="left-nav"></leftNav>
    <!--操作区域-->
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import leftNav from '@/components/common/leftNav'
export default {
  name: 'App',
  components:{
    leftNav
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
}
.left-nav{
  width: 20%;
}
.main{
  position: absolute;
  left: 210px;
  top: 0px;
  min-height: 400px;
  overflow: hidden;
  padding: 10px;
  width: 80%;
  border: 1px solid #e6e6e6;
}
</style>



// WEBPACK FOOTER //
// src/App.vue